import { createSelector } from '@ngrx/store';
import { IAppState } from '../../common/interfaces/app-state.interface';
import { IEnrollmentStore } from '../interfaces/enrollment-store.interface';

export const selectEnrollmentStore = (state: IAppState) => state.enrollment;

export const selectEnrollmentId = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) => ({
    enrollmentId: enrollmentStore.enrollmentId,
  })
);

export const selectEnrollmentStepId = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) => ({
    enrollmentStepId: enrollmentStore.enrollmentStepId,
  })
);

export const selectDashboardStateId = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) => ({
    dashboardStateId: enrollmentStore.dashboardStateId,
  })
);

export const selectBusinessProfileStatusId = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) => enrollmentStore.businessProfileStatusId
);

export const selectFinancialProfileStatusId = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) =>
    enrollmentStore.financialProfileStatusId
);

export const selectCustomerPortfolioStatusId = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) =>
    enrollmentStore.customerPortfolioStatusId
);

export const selectApplicationReviewStatusId = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) =>
    enrollmentStore.applicationReviewStatusId
);

export const selectMsaSignatureStatusId = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) => enrollmentStore.msaSignatureStatusId
);

export const selectNowAccountActivationStatusId = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) =>
    enrollmentStore.nowAccountActivationStatusId
);

export const selectModuleStatuses = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) => ({
    businessProfileStatusId: enrollmentStore.businessProfileStatusId,
    financialProfileStatusId: enrollmentStore.financialProfileStatusId,
    customerPortfolioStatusId: enrollmentStore.customerPortfolioStatusId,
    applicationReviewStatusId: enrollmentStore.applicationReviewStatusId,
    msaSignatureStatusId: enrollmentStore.msaSignatureStatusId,
    nowAccountActivationStatusId: enrollmentStore.nowAccountActivationStatusId,
  })
);

export const selectBusinessProfileStateId = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) => ({
    dashboardStateId: enrollmentStore.dashboardStateId,
    businessProfileStateId: enrollmentStore.businessProfileStateId,
  })
);

export const selectFinancialProfileStateId = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) => ({
    dashboardStateId: enrollmentStore.dashboardStateId,
    financialProfileStateId: enrollmentStore.financialProfileStateId,
  })
);

export const selectCustomerPortfolioStateId = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) => ({
    dashboardStateId: enrollmentStore.dashboardStateId,
    customerPortfolioStateId: enrollmentStore.customerPortfolioStateId,
  })
);

export const selectHasClientAdditionalInfoRequest = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) =>
    enrollmentStore.hasClientAdditionalInfoRequest
);

export const selectAllEnrollment = createSelector(
  selectEnrollmentStore,
  (enrollmentStore: IEnrollmentStore) => ({
    enrollmentId: enrollmentStore.enrollmentId,
    enrollmentStepId: enrollmentStore.enrollmentStepId,
    dashboardStateId: enrollmentStore.dashboardStateId,
    businessProfileStateId: enrollmentStore.businessProfileStateId,
    financialProfileStateId: enrollmentStore.financialProfileStateId,
    customerPortfolioStateId: enrollmentStore.customerPortfolioStateId,
    businessProfileStatusId: enrollmentStore.businessProfileStatusId,
    financialProfileStatusId: enrollmentStore.financialProfileStatusId,
    customerPortfolioStatusId: enrollmentStore.customerPortfolioStatusId,
    applicationReviewStatusId: enrollmentStore.applicationReviewStatusId,
    msaSignatureStatusId: enrollmentStore.msaSignatureStatusId,
    nowAccountActivationStatusId: enrollmentStore.nowAccountActivationStatusId,
    hasClientAdditionalInfoRequest:
      enrollmentStore.hasClientAdditionalInfoRequest,
  })
);
